module.exports = __webpack_public_path__ + "static/media/ic-card-menu.cb7f8d0b.svg";